import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from '../../components/Header';

const ManualVerification = (props) => {
  const { checkinData, navigate, params, searchParams } = props;
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  const strHeadLine = 'Unable to Sign Loan Agreement';

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <h1>{strHeadLine}</h1>
        <p>Sorry, we were unable to confirm your identity. Call 800-994-6177 Ext 3 to continue signing the loan agreement.</p>
      </div>
    </div>
  );
};

ManualVerification.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(ManualVerification);
